import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import {
  SiteUserQueriesFetchAction,
  SiteUserQueriesFetchSuccessAction,
  SiteUserQueriesState,
  SiteUserQueryFetchAction,
  SiteUserQueryFetchSuccessAction,
  UpdateCurrentQueryAction,
  UpdateCurrentQuerySuccessAction,
} from './siteUserQueries.types';

const initialState: SiteUserQueriesState = {
  loading: false,
  error: undefined,
  data: null,
  filters: {
    status: '',
    patientCode: '',
  },
  currentQuery: null,
  currentQueryLoading: false,
  currentQueryError: undefined,
  currentQueryUpdating: false,
  currentQueryUpdateError: undefined,
};

const { actReq, actReject, actResolve } = makeActionCreator<SiteUserQueriesState>();

export const siteUserQueriesSlice = createSlice({
  name: 'siteUserQueries',
  initialState,
  reducers: {
    fetchSiteUserQueries: actReq<SiteUserQueriesFetchAction['payload']>(),
    fetchSiteUserQueriesSuccess:
      actResolve<SiteUserQueriesFetchSuccessAction['payload']>('data'),
    fetchSiteUserQueriesFailure: actReject<Error>(),
    fetchCurrentQuery: actReq<SiteUserQueryFetchAction['payload']>('currentQueryLoading'),
    fetchCurrentQuerySuccess: actResolve<SiteUserQueryFetchSuccessAction['payload']>(
      'currentQuery',
      'currentQueryLoading',
      'currentQueryError'
    ),
    fetchCurrentQueryFailure: actReject(
      'currentQueryError',
      'currentQueryLoading'
    ),
    clearCurrentQuery: (state) => {
      state.currentQuery = null;
      state.currentQueryLoading = false;
      state.currentQueryError = undefined;
    },
    updateCurrentQuery: actReq<UpdateCurrentQueryAction['payload']>('currentQueryUpdating'),
    updateCurrentQuerySuccess: actResolve<UpdateCurrentQuerySuccessAction['payload']>(
      'currentQuery',
      'currentQueryUpdating',
      'currentQueryUpdateError'
    ),
    updateCurrentQueryFailure: actReject(
      'currentQueryUpdateError',
      'currentQueryUpdating'
    ),
    setFilters: (state, action) => {
      const { filterQuery, filterValue } = (action as unknown as {
        payload: {
          filterQuery?: keyof SiteUserQueriesState['filters'];
          filterValue: string;
        };
      }).payload;
      if (!filterQuery) return;
      state.filters = {
        ...state.filters,
        [filterQuery]: filterValue,
      } as SiteUserQueriesState['filters'];
    },
  },
});

export const {
  fetchSiteUserQueries,
  fetchSiteUserQueriesSuccess,
  fetchSiteUserQueriesFailure,
  fetchCurrentQuery,
  fetchCurrentQuerySuccess,
  fetchCurrentQueryFailure,
  clearCurrentQuery,
  updateCurrentQuery,
  updateCurrentQuerySuccess,
  updateCurrentQueryFailure,
} = siteUserQueriesSlice.actions;

export const actions = {
  ...siteUserQueriesSlice.actions,
};

export const useSiteUserQueriesSlice = createSliceHook(
  siteUserQueriesSlice.name,
  actions,
);
